<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <table>
              <tr>
                <td>
                  <flat-pickr @on-change="onChange" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template slot="form_type" slot-scope="data">
            Wristband
          </template>
          <template slot="name" slot-scope="data" v-if="data.item.member">
            {{data.item.member.first_name}} {{data.item.member.last_name}}
          </template>
          <template slot="date" slot-scope="data">
            {{parseDate(data.item.created_at)}}
          </template>
          <template slot="time" slot-scope="data">
            {{parseTime(data.item.created_at)}}
          </template>
          <template slot="action" slot-scope="data">
            <b-button size="sm" @click="editForm('/allForm/editCorporateOutstanding?id=' + data.item.id)" class="btn-table warning mr-1">
            <i class="far fa-edit"></i> Edit
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'allForm',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'id',
          label: 'Transaction ID',
          sortable: true
        },
        {
          key: 'corporate.name',
          label: 'Member Name',
          sortable: true
        },
        {
          key: 'date',
          label: 'Date',
          sortable: true
        },
        {
          key: 'gross_amount',
          label: 'Amount',
          sortable: true
        },
        {
          key: 'notes',
          label: 'Notes',
          sortable: true
        },
        {
          key: 'action',
          label: 'Action'
        }
      ],
      items: [],
      getId: Auth.Session.get().paradigm_id,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    onChange(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      axios({
        method: 'get',
        url: 'crm/v1/export/wristband_report?start_date='+dates[0]+'&end_date='+dates[1],
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Wristband Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY')
    },
    parseTime (value) {
      moment.locale('en')
      return moment(value).format('h:mm a')
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteForm(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/form/'.concat(event)).then(response => {
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/form_outstanding/corporate?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&start_date=' + dates1[0] + '&end_date=' + dates1[1]).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
